import { IWeekAheadTemplate } from '@/types/components/ITemplate'
import { ReleaseCard } from '../../cards/ReleaseCard'

interface WeekAheadProps {
  template: IWeekAheadTemplate
}

export const WeekAhead = ({ template: { release } }: WeekAheadProps) => {
  return (
    <>
      <div className='flex w-full justify-center'>
        <div className='relative mx-0 mb-10 flex w-full max-w-[800px] flex-col gap-2 xs:mx-6 sm:mx-12'>
          {release.map(({ text, image }, index) => (
            <ReleaseCard key={index} text={text} image={image} />
          ))}
        </div>
      </div>
    </>
  )
}
